import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SizeGroupValuesSearchModel extends SearchModel<any> {

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "id";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }

    findById(id: number): Promise<any> {
        return this.searchRecords({id: id}, undefined, undefined, undefined).toPromise()
            .then(searchData => Promise.resolve(searchData.totalCount === 1 ? searchData.data[0] : undefined));
    }
}
